import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert2'

import ToggleSwitchLabeled from 'srs.sharedcomponents/lib/esm/components/atoms/ToggleSwitchLabeled/ToggleSwitchLabeled'
import LoadingIndicator from 'srs.sharedcomponents/lib/esm/components/organisms/LoadingIndicator/LoadingIndicator'
import {
  useAppSelector,
  useAppDispatch,
} from 'srs.sharedcomponents/lib/esm/redux/hooks'
import {
  customerDunningBlockInfo,
  userLanguage,
} from 'srs.sharedcomponents/lib/esm/redux/slices/userSlice'
import { selectIsFormatDate, selectDateFormat } from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice'
import {
  AnonymousCartValues,
  BusinessRegion,
  stateStatus,
} from 'srs.sharedcomponents/lib/esm/utils/enums'
import AutoRenewModal, { ModalType } from './AutoRenewModal'
import { ILSMSubscriptionHistory } from 'srs.sharedcomponents/lib/esm/models/responses/lsmOrderResponse.model'
import {
  getLsmOrder,
  cancelSubscription,
  revokeSubscription,
} from 'srs.sharedcomponents/lib/esm/redux/slices/subscriptionSlice'
import ChevronUp from 'srs.sharedcomponents/lib/esm/assets/icons/chevronUp'
import ChevronDown from 'srs.sharedcomponents/lib/esm/assets/icons/chevronDown'
import ShoppingCartIcon from './ShoppingCartIcon'
import MailIcon from './MailIcon'
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import { Container } from 'react-bootstrap'
import { styles } from './subscriptions.styles'
import NotFoundPageComponent from 'srs.sharedcomponents/lib/esm/shared-components/srs.notFoundPage.component'
import { SkeletonGroup } from './SkeletonComponents'
import { getEnvBoolean } from 'srs.sharedcomponents/lib/esm/api/env'
import { locales } from 'srs.sharedcomponents/lib/esm/utils/dictionaries'
import {
  addItemToDB,
  anonymousCartId,
} from 'srs.sharedcomponents/lib/esm/redux/slices/cartSlice'
import { IAddToCartRequest } from 'srs.sharedcomponents/lib/esm/models/reguests/cart/srs.addToCartRequest.model'
import { formatDate } from 'srs.sharedcomponents/lib/esm/utils/helpers'
import HoverTooltip from '../HoverTooltip'
export default function MySubscriptions() {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const history = useHistory()
  const dunningblock = useAppSelector(customerDunningBlockInfo)
  const user = useAppSelector((state: any) => state.user?.user)
  const { lsmOrderData, status: subscriptionStatus } = useAppSelector(
    (state) => state.subscription,
  )

  const [data, setData] = useState<ILSMSubscriptionHistory[]>([])
  const [expandedRow, setExpandedRow] = useState<string | null>(null)
  const [showModal, setShowModal] = useState(false)
  const [modalType, setModalType] = useState<ModalType>('cancel')
  const [selectedSubscription, setSelectedSubscription] =
    useState<ILSMSubscriptionHistory | null>(null)
  const [updatedSubscriptionData, setUpdatedSubscriptionData] =
    useState<ILSMSubscriptionHistory | null>(null)
  const [isProcessing, setIsProcessing] = useState(false)
  const userLang = useAppSelector(userLanguage)
  const isFormatDate = useAppSelector(selectIsFormatDate)
  const dateFormat = useAppSelector(selectDateFormat)
  let lang = userLang ? locales.get(userLang) : locales.get(1033)

  const userEmail = useAppSelector((state: any) => state.user?.user?.email)
  const anonymousCartIdFromSlice = useAppSelector(anonymousCartId)

  const isUserLoggedIn = !!user
  const isEmeaRegion = user?.region?.shortName === BusinessRegion.EMEA
  const isAuthorized =
    isUserLoggedIn &&
    isEmeaRegion &&
    getEnvBoolean('REACT_APP_SHOW_USER_SUBSCRIPTION')

  useEffect(() => {
    if (!isAuthorized) return

    const lsmOrderParams = {
      Count: 5,
      OrderSummaryLevel: [7],
    }

    dispatch(getLsmOrder(lsmOrderParams))
  }, [dispatch, isAuthorized])

  useEffect(() => {
    if (!isAuthorized) return

    if (lsmOrderData && lsmOrderData.subscriptionHistories) {
      setData(lsmOrderData.subscriptionHistories)
    }
    console.log('lsmOrderData', lsmOrderData)
  }, [lsmOrderData, isAuthorized])

  if (!isAuthorized) {
    history.push('/login')
  }

  const DateFormat = (date: Date | string | undefined) => {
    if (isFormatDate && dateFormat) {
      return formatDate(date, lang?.replace('_', '-') || 'en-US',isFormatDate, dateFormat)
    }
    const dateObj = typeof date === 'string' ? new Date(date) : date
    const formattedLanguage = dateObj?.toLocaleDateString(
      lang?.replace('_', '-'),
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
    )
    return formattedLanguage
  }

  const getSubscriptionUIState = (subscription: ILSMSubscriptionHistory) => {
    const now = new Date()
    const cancelDate = subscription.subscriptionCancellationDate
      ? new Date(subscription.subscriptionCancellationDate)
      : null

    const status = subscription.status?.toLowerCase()
    const renewable = subscription.renewable ?? false
    const renewedAutomatically = subscription.renewedAutomatically ?? false
    if (status === 'canceled') {
      return {
        showContactUs: false,
        showToggle: true,
        toggleChecked: false,
        toggleDisabled: false,
        showBuy: false,
        actionText: t('MySubscriptionsAutoRenewOff'),
      }
    }

    if  (
      status === 'active' &&
      renewable &&
      renewedAutomatically &&
      cancelDate &&
      cancelDate < now
    ) {
      return {
        showContactUs: false,
        showToggle: true,
        toggleChecked: true,
        toggleDisabled: true,
        showBuy: false,
        actionText: t('MySubscriptionsAutoRenewOn'),
      }
    }

    if (
      status === 'active' &&
      renewable &&
      renewedAutomatically &&
      cancelDate &&
      cancelDate >= now
    ) {
      return {
        showContactUs: false,
        showToggle: true,
        toggleChecked: true,
        toggleDisabled: false,
        showBuy: false,
        actionText: t('MySubscriptionsAutoRenewOn'),
      }
    }

    if (status === 'active' && !renewable) {
      return {
        showContactUs: false,
        showToggle: true,
        toggleChecked: false,
        toggleDisabled: false,
        showBuy: false,
        actionText: t('MySubscriptionsAutoRenewOff'),
      }
    }

    if (status === 'expired' || status === 'inactive') {
      const isDunningBlocked = dunningblock?.isDunningBlocked ?? false

      return {
        showContactUs: false,
        showToggle: false,
        toggleChecked: false,
        toggleDisabled: false,
        showBuy: !isDunningBlocked,
        actionText: t('MySubscriptionsBuyAction'),
      }
    }

   return {
        showContactUs: true,  
        showToggle: false,
        toggleChecked: false,
        toggleDisabled: false,
        showBuy: false,
        actionText: t('MySubscriptionsContactUsAction'),
        contactEmail: 'CSS2@Bosch-Automotive.com',
  }
}

  const handleContactUs = (email: string) => {
    window.open(`mailto:${email}`, 'email')
  }

  const handleBuy = async (subscription: ILSMSubscriptionHistory) => {
    history.push(`/ItemDetail?SKU=${subscription.sku}`)
  }

  const toggleExpand = (orderNo: string) => {
    setExpandedRow(expandedRow === orderNo ? null : orderNo)
  }

  const handleToggle = (orderNo: string) => {
    const subscription = data.find((sub) => sub.orderNo === orderNo)
    if (!subscription) return

    const currentUIState = getSubscriptionUIState(subscription)
    const currentState = currentUIState.toggleChecked

    setSelectedSubscription(subscription)

    if (currentState) {
      setModalType('cancel')
    } else {
      setModalType('confirm-on')
    }

    setShowModal(true)
  }

  const mergeSubscriptionData = (
    response: any,
    baseSubscription: ILSMSubscriptionHistory,
  ): ILSMSubscriptionHistory => ({
    ...baseSubscription,
    status: response.status || baseSubscription.status,
    renewable: response.renewable ?? baseSubscription.renewable,
    renewedAutomatically:
      response.renewedAutomatically ?? baseSubscription.renewedAutomatically,
    subscriptionCancellationDate:
      response.subscriptionCancellationDate ||
      baseSubscription.subscriptionCancellationDate,
    subscriptionStartDate:
      response.subscriptionStartDate || baseSubscription.subscriptionStartDate,
    subscriptionEndDate:
      response.subscriptionEndDate || baseSubscription.subscriptionEndDate,
    lastRenewedDate:
      response.lastRenewedDate || baseSubscription.lastRenewedDate,
    dateOfExpiration:
      response.dateOfExpiration || baseSubscription.dateOfExpiration,
    nextRenewalEndDate:
      response.nextRenewalEndDate || baseSubscription.nextRenewalEndDate,
  })

  const updateSubscriptionInData = (
    updatedSubscription: ILSMSubscriptionHistory,
  ) => {
    setData((prevData) =>
      prevData.map((subscription) =>
        subscription.subscriptionId === selectedSubscription?.subscriptionId
          ? updatedSubscription
          : subscription,
      ),
    )
    setUpdatedSubscriptionData(updatedSubscription)
  }

  const handleModalConfirm = async () => {
    if (!selectedSubscription) return

    setShowModal(false)
    setIsProcessing(true)

    try {
      const subscriptionParams = {
        subscriptionId: selectedSubscription.subscriptionId,
        isOwner: false,
      }

      let response: any
      let nextModalType: ModalType

      if (modalType === 'cancel') {
        response = await dispatch(
          cancelSubscription(subscriptionParams),
        ).unwrap()
        nextModalType = 'cancel-success'
      } else if (modalType === 'confirm-on') {
        response = await dispatch(
          revokeSubscription(subscriptionParams),
        ).unwrap()
        nextModalType = 'success'
      } else {
        return
      }

      const updatedSubscription = mergeSubscriptionData(
        response,
        selectedSubscription,
      )

      updateSubscriptionInData(updatedSubscription)

      setModalType(nextModalType)
      setShowModal(true)
    } catch (error) {
      swal.fire({
        title: t('errorSwal'),
        text: t('MySubscriptionsErrorAlertMessage'),
        icon: 'error',
        confirmButtonText: t('btnOkText'),
      })
    } finally {
      setIsProcessing(false)
      setSelectedSubscription(null)
    }
  }

  const handleModalClose = () => {
    setShowModal(false)
    setSelectedSubscription(null)
    setUpdatedSubscriptionData(null)
    setIsProcessing(false)
  }

  const getCurrentSubscriptionData = () => {
    return updatedSubscriptionData || selectedSubscription
  }

  const skuGroupMapper = (sku: string): string | null => {
    const lowerSku = sku.toLowerCase()

    if (lowerSku.includes('ford-ltp')) {
      return t('MySubscriptionsGroupFordLtpAnnualLicense')
    }

    if (lowerSku.includes('tn-') || lowerSku.includes('toolnet')) {
      return t('MySubscriptionsGroupToolnetAnnualLicense')
    }

    return null
  }

  const sortSubscriptionsByStatusAlphabetically = (
    subscriptions: ILSMSubscriptionHistory[],
  ): ILSMSubscriptionHistory[] => {
    return [...subscriptions].sort((a, b) => {
      const statusA = (a.status || '').toUpperCase()
      const statusB = (b.status || '').toUpperCase()

      if (statusA !== statusB) {
        return statusA.localeCompare(statusB)
      }

      return (a.orderNo || '').localeCompare(b.orderNo || '')
    })
  }

  const groupedSubscriptions = (() => {
    const groups = data.reduce(
      (acc, subscription) => {
        const sku = subscription.sku || ''
        const groupKey = skuGroupMapper(sku)

        if (groupKey && acc[groupKey]) {
          acc[groupKey].push(subscription)
        }

        return acc
      },
      {
        [t('MySubscriptionsGroupToolnetAnnualLicense')]: [],
        [t('MySubscriptionsGroupFordLtpAnnualLicense')]: [],
      } as Record<string, ILSMSubscriptionHistory[]>,
    )

    Object.keys(groups).forEach((groupKey) => {
      groups[groupKey] = sortSubscriptionsByStatusAlphabetically(
        groups[groupKey],
      )
    })

    return groups
  })()

  const isLoading = subscriptionStatus === stateStatus.loading || isProcessing

  const currentSubscription = getCurrentSubscriptionData()
  const getTranslatedStatus = (subscription: ILSMSubscriptionHistory) => {
  const status = subscription.status?.toLowerCase()
  const renewable = subscription.renewable ?? false
  const renewedAutomatically = subscription.renewedAutomatically ?? false
  
  let text = ''
  let style = styles.statusBlocked
  
  switch (status) {
    case 'active':
      text = t('txtMySubscriptionsStatusActive')
      style = styles.statusActive
      break
    case 'inactive':
      text = t('txtMySubscriptionsStatusExpired')
      style = styles.statusExpired
      break
    case 'expired':
      text = t('txtMySubscriptionsStatusExpired')
      style = styles.statusExpired
      break
    case 'canceled':
      if(renewable && renewedAutomatically) {
        text = t('txtMySubscriptionsStatusActive')
        style = styles.statusActive
      } else {
        text = t('SubscriptionsBlocked')
        style = styles.statusExpired
      }
      break
    default:
      text = t('SubscriptionsBlocked')
      style = styles.statusBlocked
  }
  
  return { text, style }
}
  return (
    <Container style={styles.subscriptionContainer}>
      <h2 style={styles.pageTitle}>{t('MySubscriptionsPageTitle')}</h2>

      {isLoading && (
        <>
          <SkeletonGroup
            title={t('MySubscriptionsGroupToolnetAnnualLicense')}
          />
          <SkeletonGroup
            title={t('MySubscriptionsGroupFordLtpAnnualLicense')}
          />
        </>
      )}

      {!isLoading &&
        Object.entries(groupedSubscriptions).map(
          ([groupName, subscriptions]) => (
            <div key={groupName}>
              <h4 style={styles.subscriptionGroupTitle}>{groupName}</h4>
              <div style={styles.subscriptionCard}>
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{ border: 'none', boxShadow: 'none' }}
                >
                  <Table
                    sx={{
                      minWidth: 650,
                      tableLayout: 'fixed',
                      width: '100%',
                    }}
                    size="small"
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          height: '60px',
                          backgroundColor: '#edf0f4',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '120px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderOrderNo')}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '140px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderDealershipId')}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '100px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderStartDate')}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '100px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderEndDate')}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '130px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderCancellationDeadline')}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '100px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderStatus')}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            width: '200px',
                          }}
                        >
                          {t('MySubscriptionsTableHeaderActions')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {subscriptions.length > 0 ? (
                        subscriptions.map((row) => (
                          <>
                            <TableRow
                              key={row.orderNo}
                              sx={{
                                '&:hover': { backgroundColor: '#f9f9f9' },
                                height: '60px',
                                borderBottom: '1px solid #e0e0e0',
                              }}
                            >
                              <TableCell>{row.orderNo}</TableCell>
                              <TableCell>{row.dealershipId}</TableCell>
                              <TableCell>
                                {DateFormat(row.subscriptionStartDate)}
                              </TableCell>
                              <TableCell>
                                {DateFormat(row.subscriptionEndDate)}
                              </TableCell>
                              <TableCell>
                                {row.status?.toLowerCase() !== 'canceled'
                                  ? DateFormat(row.subscriptionCancellationDate)
                                  : ''}
                              </TableCell>

                              <TableCell sx={{ textAlign: 'left' }} >
                                {(() => {
                                  const statusInfo = getTranslatedStatus(row)
                                  return (
                                    <span style={statusInfo.style}>
                                      {statusInfo.text}
                                    </span>
                                  )
                                })()} 
                              </TableCell>

                              <TableCell
                                sx={{
                                  padding: '16px 16px',
                                  verticalAlign: 'middle',
                                  width: '200px',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    minHeight: '32px',
                                  }}
                                >
                                  <div style={styles.actionButtonContainer}>
                                    {(() => {
                                      const uiState =
                                        getSubscriptionUIState(row)

                                      return (
                                         <>
                                          {uiState.showToggle && (
                                            <div style={styles.toggleWrapper}>
                                              <HoverTooltip 
                                              anchorWidth={60}   
                                                message={
                                                  uiState.toggleDisabled
                                                    ? t(
                                                        'MySubscriptionsToggleDisabledTooltip',
                                                        {
                                                          cancellationDeadline:
                                                            DateFormat(
                                                              row.subscriptionCancellationDate,
                                                            ),
                                                          nextTermStartDate:
                                                            DateFormat(
                                                              row.dateOfExpiration,
                                                            ),
                                                          interpolation: {
                                                            escapeValue: false,
                                                          },
                                                        },
                                                      )
                                                    : ''
                                                }
                                              >
                                                <ToggleSwitchLabeled
                                                  checked={uiState.toggleChecked}
                                                  onChange={() =>
                                                    handleToggle(row.orderNo)
                                                  }
                                                  labelOn={t(
                                                    'MySubscriptionsToggleLabelOn',
                                                  )}
                                                  labelOff={t(
                                                    'MySubscriptionsToggleLabelOff',
                                                  )}
                                                  disabled={uiState.toggleDisabled || isProcessing}   
                                                />
                                              </HoverTooltip>    
                                            </div>
                                          )}

                                          {uiState.showBuy && (
                                            <div style={styles.buttonWrapper}>
                                              <button
                                                style={styles.buyBtn}
                                                onClick={() => handleBuy(row)}
                                              >
                                                <ShoppingCartIcon width={12} height={12} fill="white" />
                                                {t('MySubscriptionsBuyButton')}
                                              </button>
                                            </div>
                                          )}

                                          {uiState.showContactUs && (
                                            <div style={styles.buttonWrapper}>
                                              <button
                                                style={styles.contactBtn}
                                                onClick={() =>
                                                  handleContactUs(
                                                    uiState.contactEmail ||
                                                      'CSS2@Bosch-Automotive.com',
                                                  )
                                                }
                                              >
                                                <MailIcon width={16} height={16} fill="white" />
                                                {t('Footer_ContactUsLinkText')}
                                              </button>
                                            </div>
                                          )}
                                        </>
                                      )
                                    })()}
                                  </div>

                                  <span
                                    style={styles.expandArrow}
                                    onClick={() => toggleExpand(row.orderNo)}
                                  >
                                    {expandedRow === row.orderNo ? (
                                      <ChevronUp />
                                    ) : (
                                      <ChevronDown />
                                    )}
                                  </span>
                                </div>
                              </TableCell>
                            </TableRow>

                            {expandedRow === row.orderNo && (
                              <TableRow>
                                <TableCell
                                  colSpan={7}
                                  sx={{
                                    backgroundColor: '#f8f9fa',
                                    borderBottom: '1px solid #e0e0e0',
                                  }}
                                >
                                  <div style={styles.nestedContent}>
                                    {[
                                      {
                                        label: t(
                                          'MySubscriptionsDetailLabelOrderDate',
                                        ),
                                        value: DateFormat(row.orderDate),
                                      },
                                      {
                                        label: t(
                                          'MySubscriptionsDetailLabelSubscriptionId',
                                        ),
                                        value: row.subscriptionId,
                                      },
                                      {
                                        label: t(
                                          'MySubscriptionsDetailLabelSubscriptionName',
                                        ),
                                        value: (
                                          <button
                                            style={styles.subscriptionNameLink}
                                            onClick={() => handleBuy(row)}
                                          >
                                            {row.subscriptionName}
                                          </button>
                                        ),
                                      },
                                      {
                                        label: t(
                                          'MySubscriptionsDetailLabelFirstOrdered',
                                        ),
                                        value: DateFormat(row.firstOrderedDate),
                                      },
                                      {
                                        label: t(
                                          'MySubscriptionsDetailLabelLastRenewed',
                                        ),
                                        value: DateFormat(row.lastRenewedDate),
                                      },
                                    ].map((detail) => (
                                      <div
                                        style={styles.subscriptionDetail}
                                        key={detail.label}
                                      >
                                        <div
                                          style={{
                                            ...styles.detailLabel,
                                            fontWeight: 'bold',
                                          }}
                                        >
                                          {detail.label}
                                        </div>
                                        <div style={styles.detailValue}>
                                          {detail.value}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </TableCell>
                              </TableRow>
                            )}
                          </>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={7}
                            sx={{
                              textAlign: 'center',
                              padding: '20px',
                              color: '#666',
                              fontStyle: 'italic',
                              borderBottom: 'none',
                            }}
                          >
                            {t('MySubscriptionsEmptyStateTitle')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          ),
        )}

      <AutoRenewModal
        open={showModal}
        type={modalType}
        onConfirm={handleModalConfirm}
        onCancel={handleModalClose}
        onClose={handleModalClose}
        subscriptionEndDate={
          currentSubscription?.subscriptionEndDate
            ? DateFormat(currentSubscription.subscriptionEndDate)
            : undefined
        }
        cancellationDeadline={
          currentSubscription?.subscriptionCancellationDate
            ? DateFormat(currentSubscription.subscriptionCancellationDate)
            : undefined
        }
        nextTermStartDate={
          currentSubscription?.dateOfExpiration
            ? DateFormat(currentSubscription.dateOfExpiration)
            : undefined
        }
        nextTermEndDate={
          currentSubscription?.nextRenewalEndDate
            ? DateFormat(currentSubscription.nextRenewalEndDate)
            : undefined
        }
        userEmail={userEmail}
      />
    </Container>
  )
}
